import { Logger } from './logger';
import { Utils } from './utils';

/**
 * Class Span takes all span elements with the class ".e-counter"
 * and if they contain an integer, this integer will be counted
 * to in the innerHTML (starting from 0) once,
 * as soon as this span is in the viewport.
 */
export class Counter {
  /**
   * The constructor queries all span elements with the class ".e-counter"
   * and if they contain an integer, for each a SpanCounter
   * is instantiated which handles the counting.
   *
   * @param $log  The instance of ./02_utils/logger/logger.ts
   * @param $utils The instance of ./02_utils/utils/Utils.ts
   */
  public constructor(private $log: Logger, private $utils: Utils) {
    let spanCountElems = document.querySelectorAll('span.e-counter') as NodeListOf<HTMLSpanElement>;
    if (spanCountElems != null) {
      spanCountElems.forEach((spanCountElem) => {
        const textContent = spanCountElem.innerText;
        const numMatch = textContent.match(/\d+/); // Find the first sequence of digits
        if (numMatch) {
          const num = Number(numMatch[0]);
          const prefix = textContent.substring(0, numMatch.index);
          const suffix = textContent.substring(numMatch.index + numMatch[0].length);

          spanCountElem.innerText = `${prefix}0${suffix}`;

          // Options for the IntersectionObserver
          const options: IntersectionObserverInit = {
            root: null, // Use the viewport as the root
            threshold: 0.5 // Trigger when 50% of the target is in view
          };

          // Create an IntersectionObserver
          const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                // Start counting
                this.countUpTo(num, 3500, spanCountElem, prefix, suffix);
                // Stop observing once the function has been called
                observer.disconnect();
              }
            });
          }, options);

          observer.observe(spanCountElem);
        }
      });
    }
  }

  private countUpTo(targetValue: number, duration: number, element: HTMLElement, prefix: string, suffix: string): void {
    let counter = 0;
    let startTime: number;

    const updateCounter = () => {
      const currentTime = Date.now();
      const elapsedTime = currentTime - startTime;
      if (elapsedTime < duration) {
        counter = Math.floor((elapsedTime / duration) * targetValue);
        element.innerText = `${prefix}${counter.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".")}${suffix}`;
        requestAnimationFrame(updateCounter);
      } else {
        counter = targetValue;
        element.innerText = `${prefix}${counter.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".")}${suffix}`;
      }
      console.log(element.innerText);
    };

    const startCounting = () => {
      startTime = Date.now();
      updateCounter();
    };

    startCounting();
  }
}
